module.exports = __webpack_public_path__ + "static/media/FRP-February-Headphones-Giveaway.0a998abd.jpg";